var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { OGFileTracker } from '@opengear/file-uploader';
export function FileManagerTracker(_a) {
    var data = _a.data, onCancel = _a.onCancel;
    var t = useTranslation().t;
    var handleCancel = data.status === 'pending' ? onCancel : undefined;
    var message = useMemo(function () {
        if (data.status === 'pending') {
            return _jsx(Typography, { children: t('components.file_manager.progress.pending') });
        }
        if (data.status === 'success') {
            return (_jsxs(Box, __assign({ display: "flex", alignItems: "center", gap: 0.75 }, { children: [_jsx(CheckOutlinedIcon, { color: "success", fontSize: "medium" }), _jsx(Typography, { children: t('components.file_manager.progress.success') })] })));
        }
        if (data.status === 'error' && data.errorMessage) {
            return (_jsxs(Box, __assign({ display: "flex", alignItems: "center", gap: 0.75 }, { children: [_jsx(ErrorOutlineIcon, { color: "warning", fontSize: "medium" }), _jsx(Typography, { children: data.errorMessage })] })));
        }
        return null;
    }, [data.errorMessage, data.status, t]);
    var progress = data.status !== 'error' ? (data.loaded / data.total) * 100 : undefined;
    return _jsx(OGFileTracker, { id: data.filename, name: data.filename, message: message, progress: progress, onCancel: handleCancel });
}
